import pulse, { type TrackerData } from '@finn-no/pulse-sdk';
import type { PolePositionEntry, PulseTracking } from '../../server';

export function trackAdInscreen(
    ad: PolePositionEntry,
    tracking: PulseTracking,
) {
    const trackerData: TrackerData = {
        type: 'View',
        intent: 'Open',
        name: 'Search result viewed',
        object: {
            type: 'ListingItem',
            id: `classified:${ad.id}`,
            name: 'Search result',
            rank: 0,
            isTopPositionPremiumFeature: true,
            paidPromotionTypes: ['fus'],
            paidPromotions: tracking.paidPromotions,
        },
    };

    pulse.trackEvent(trackerData);
}

export function trackAdClick(ad: PolePositionEntry, tracking: PulseTracking) {
    const trackerData: TrackerData = {
        type: 'Click',
        intent: 'Open',
        name: 'Search result clicked',
        object: {
            type: 'ListingItem',
            id: `classified:${ad.id}`,
            name: 'Search result',
            rank: 0,
            isTopPositionPremiumFeature: true,
            paidPromotionTypes: ['fus'],
            paidPromotions: tracking.paidPromotions,
        },
        target: {
            type: 'ClassifiedAd',
            id: ad.id,
            name: `${ad.heading}`,
            category: 'n/a',
            contentId: ad.id,
        },
    };

    const isBap = ad.main_search_key?.includes('BAP');
    const clothingSizeTracking = isBap
        ? [
              {
                  type: 'MarketplaceItem',
                  id: `classified:${ad.id}`,
                  size: ad.extras
                      .some((extra) => extra.id === 'clothing_size')
                      .toString(),
              },
          ]
        : undefined;

    if (clothingSizeTracking) {
        trackerData.object!.items = clothingSizeTracking;
    }

    pulse.trackEvent(trackerData);
}
